import React, { useEffect } from 'react';
import ZipCodeInput from './ZipCodeInput';
import { MAPPING } from '../helpers';
import AnimationScrollPage from '../../../../components/AnimationScrollPage';
import { CLICK_EVENT_ACTION_TYPE, CLICK_EVENT_TRIGGER, CTA_ACTION_CATEGORY } from '../../../../constants';
import { MODULE_NAME } from '../helpers/constant';

const Heading = () => {

  useEffect(() => {
    new AnimationScrollPage().init();
  }, []);

  const { linkView, title, linkViewText, zipCodePlaceholder, invalidZipCodeText } = MAPPING;
  return (
    <div className="flex down_xl:flex-wrap justify-between items-center pt-33 pb-20 animation">
      <h2 className="h4 mb-16 lg:mb-0 mr-23 anima-bottom">{title}</h2>
      <ZipCodeInput
        zipCodePlaceholder={zipCodePlaceholder}
        invalidZipCodeText={invalidZipCodeText}
        classWidth="lg:max-w-[338px] xl:max-w-[200px] anima-bottom delay-1"
        submitButtonIconClass="icon-arrow-right-animation"
      />
      <div className="md:ml-auto hidden xl:block anima-bottom delay-2">
        <a className="btn btn-ani btn-outline-primary m-0" href={linkView}
          data-event-trigger={CLICK_EVENT_TRIGGER}
          data-event-type={CLICK_EVENT_ACTION_TYPE}
          data-event-module={MODULE_NAME}
          data-event-label={linkViewText}
          data-event-category={CTA_ACTION_CATEGORY}
        >
          {linkViewText}
          <span className="relative overflow-hidden inline-flex">
            <span className="icomoon icon-arrow-right-animation" aria-hidden="true" />
            <span className="icomoon icon-arrow-right-animation absolute -left-11" aria-hidden="true" />
          </span>
        </a>
      </div>
    </div>
  );
};
export default Heading;